import {combineReducers} from 'redux';
import types from './types';

const loginInfo = (state = null, action) => {
  switch (action.type) {
    case types.DO_LOGIN:
      return action.loginInfo;
    default:
      return state;
  }
};

const isLoggedIn = (state = false, action) => {
  switch (action.type) {
    case types.DO_LOGIN:
      return action.loginInfo.isLoggedIn;
    case types.DO_LOGOUT:
      return false;
    default:
      return state;
  }
};

const userInfo = (state = null, action) => {
  switch (action.type) {
    case types.GET_USER_INFO:
      return action.userInfo;
    default:
      return state;
  }
};

// ユーザー権限
const userPerms = (state = null, action) => {
  switch (action.type) {
    case types.SET_USER_PERMS:
      return action.userPerms;
    default: return state;
  }
};

// ユーザー情報変更検出ハッシュ
const authorizedHash = (state = null, action) =>{
  switch (action.type) {
    case types.AUTHORIZED_HASH:
      return action.authorizedHash;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isLoggedIn,
  loginInfo,
  userInfo,
  userPerms,
  authorizedHash,
});

export default reducer;
